import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './about.css';

const About = () => {
  return (
    <div className="about-container">
      <Navbar />
        <div className="about-page">
            <h1>About LeetEngineer</h1>
            <p>
                LeetEngineer is an innovative AI-powered platform designed to revolutionize the way engineering candidates prepare for job interviews and build standout resumes. 
                Founded with the mission to empower engineers worldwide, we provide instant, tailored technical interview practice and professional resume creation that adapts to your specific role and company.
            </p>
            <p>
                Our platform leverages advanced AI technology to analyze job postings and generate role-specific, structured visual technical questions along with detailed answer guides, plus create compelling resumes from scratch or tailored to specific job requirements. 
                Whether you're in mechanical, aeronautical, civil, electrical, chemical, biomedical, or any other engineering field, LeetEngineer ensures you're ready to ace your interviews and showcase your skills effectively.
            </p>
            <p>
                Trusted by top engineers globally, LeetEngineer bridges the gap between job requirements and interview success, making preparation efficient, effective, and personalized.
            </p>
            <h2>Our Vision</h2>
            <p>
                To make technical interview preparation accessible, accurate, and stress-free for every engineer, regardless of their field or experience level.
            </p>
            <h2>Why Choose LeetEngineer?</h2>
            <ul>
                <li>Instant generation of tailored interview questions and answers</li>
                <li>AI-powered resume builder from scratch or job-specific</li>
                <li>Support for all engineering disciplines and HR screening</li>
                <li>AI-trained on thousands of real interview experiences</li>
                <li>Secure and private data handling</li>
                <li>User-friendly interface for seamless preparation</li>
            </ul>
        </div>
       <Footer />
    </div>
  );
};

export default About;
